<template>
  <div>
    <breadcrumbs :crumbs="[]">
      <div class="folders-breadcrumbs">
        <a @click="goToReports">Reports</a>
        <template v-for="breadcrumb, idx in path">
          <a class="folder-path-link" @click="goToFolder(breadcrumb.id)" v-if="idx > 0">
            <i class="fa" :class="{'fa-folder-o' : idx !== path.length-1, 'fa-folder-open-o' : idx === path.length-1 }"></i>{{ breadcrumb.name }}</a><i v-if="idx !== path.length-1" class="fa fa-angle-right"></i>
        </template>
      </div>
    </breadcrumbs>

    <div class="row">
      <div class="col-md-12">
        <div class="portlet light">
          <div class="portlet-title tabbable-line">
            <div class="caption caption-md">
              <span class="caption-subject font-dark sbold uppercase">{{report.name}}</span>
            </div>

            <ul class="nav nav-tabs">
              <li :class="{active: activeTab === 'results'}" @click="setActiveTab('results')">
                <a href="#results" data-toggle="tab" aria-expanded="false">Results</a>
              </li>
              <li :class="{active: activeTab === 'summary', disabled: (isGenerating || isLoading.reports)}" @click.prevent="setActiveTab('summary')">
                <a href="#summary" data-toggle="tab" aria-expanded="false">Summary</a>
              </li>
              <li :class="{active: activeTab === 'charts', disabled: (isGenerating || isLoading.reports)}" @click.prevent="setActiveTab('charts')">
                <a href="#charts" data-toggle="tab" aria-expanded="false">Charts</a>
              </li>
              <li :class="{active: activeTab === 'export', disabled: (isGenerating || isLoading.reports)}" @click.prevent="onExportTabClick">
                <a aria-expanded="false">Export</a>
              </li>
            </ul>
          </div>

          <div class="tab-content marginTop">
            <div class="tab-pane" :class="{active: activeTab === 'results'}" id="report-results">
              <h5>{{ report.description }}</h5>

              <div class="portlet-body">
                <div class="form-body">
                  <spinner v-if="!Object.keys(report).length"/>
                  <report-table :total-rows="totalRows" :report="report" :loading="showLoader" :generating="isGenerating" @refresh-report="onRefreshReport"></report-table>
                </div>
                <div class="edit-report-btn" v-if="user.access > 3 && !report.parent_id">
                  <router-link :to="{ name: 'Reports Edit', params: { reportid: $route.params.reportid } }" tag="a" :class="['btn','green']">Edit</router-link>
                </div>
              </div>

            </div>

            <div v-if="activeTab=='summary'" class="tab-pane" :class="{active: activeTab == 'summary'}" id="report-summary">
              <report-summary :report-id="report.id"></report-summary>
            </div>

            <div v-if="activeTab=='charts'" class="tab-pane" :class="{active: activeTab == 'charts'}" id="report-charts">
              <report-charts :report-id="report.id"></report-charts>
            </div>

          </div>
        </div>
      </div>
    </div>

    <export-modal v-if="showExportModal"
                  :report-id="report.id"
                  :result-total-rows="totalRows"
                  v-on:display="showExportModal = $event">
    </export-modal>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import Spinner from '@/components/Spinner';
  import {mapActions, mapGetters} from 'vuex';
  import ExportModal from "./ExportModal";
  import ReportTable from "./ReportTable";
  import ReportSummary from "./ReportSummary";
  import ReportCharts from "./ReportCharts";

  export default {
    data() {
      return {
        activeTab: 'results',
        resultsOffset: 0,
        resultsLimit: 10,
        resultsPerPage: 10,
        totalRows: 0,
        showExportModal: false
      }
    },
    components: {
      ReportTable,
      ExportModal,
      ReportSummary,
      ReportCharts,
      Breadcrumbs,
      Spinner
    },
    mounted() {
      if (this.$route.hash && this.$route.hash.length > 1) {
        this.setActiveTab(this.$route.hash.substr(1));
      } else {
        this.$router.replace({name: 'Reports View', hash: '#results'});
      }

      this.loadReport({
        id: this.$route.params.reportid,
        offset: this.resultsOffset,
        limit: this.resultsLimit
      });
    },
    computed: {
      ...mapGetters({
        report: 'getReport',
        user: 'getUser',
        isLoading: 'getReportsLoading',
        isGenerating: 'getReportGenerating',
        path: 'getPath',
        organization: 'getOrganization'
      }),
      showLoader() {
        return this.isLoading.reports === true;
      },
      isPreview() {
        return this.report.isPreview;
      }
    },
    methods: {
      ...mapActions({
        loadReport: 'GET_REPORT_ACTION',
        downloadReport: 'GENERATED_REPORT_ACTION',
        setFolderIdAction: 'SET_FOLDER_ID_ACTION'
      }),
      onExportTabClick() {
        if(this.isGenerating || this.isLoading.reports || this.isLoading.summary) {
          return;
        }
        this.showExportModal = true;
      },
      setActiveTab(activeTabTitle) {
        if(this.isGenerating || this.isLoading.reports || this.isLoading.summary) {
          return;
        }
        this.activeTab = activeTabTitle;
        this.$router.push({name: 'Reports View', hash: '#' + activeTabTitle});
      },

      changeDate() {
        this.loadReport({id: this.$route.params.reportid, data: this.range});
      },
      downloadReportType(type) {
        this.downloadReport({
          id: this.$route.params.reportid,
          timezone: this.user.time_zone,
          token: localStorage.getItem('id_token'),
          format: type
        })
      },
      onRefreshReport(offset, limit, sortBy, sortDir) {
        this.loadReport({
          id: this.$route.params.reportid,
          offset: offset,
          limit: limit,
          sortBy: sortBy,
          sortDir: sortDir
        });
      },
      goToFolder(folderId) {
        this.setFolderIdAction(folderId);
        this.$router.push({name: 'Reports Index'});
      },
      goToReports() {
        this.setFolderIdAction(null);
        this.$router.push({name: 'Reports Index', params: {reset: true}});
      }
    },
    watch: {
      '$route.hash': function (newVal) {
        this.setActiveTab(newVal.split('#')[1]);
      }
    }
  }
</script>

<style scoped lang="scss">
  .portlet {
    overflow: hidden;
    .nav-tabs li.disabled a {
      color: #ccc;
    }
  }

  .portlet > .portlet-title > .actions .btn-icon-only.btn-default > i {
    font-size: 26px;
  }


  .edit-report-btn {
    margin-top: 1em;
    clear: both;
    display: inline-block;
    float: right;
  }
</style>



// WEBPACK FOOTER //
// ReportView.vue?de6284bc